import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'typeahead'
})
export class TypeaheadPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let data;
    let key = (args[1] == undefined) ? "title" : args[1];

    if (value) {
      data = value.map((item) => {

        let re = new RegExp(args[0], "i");

        return {id: item.id, [key]: item[key].toString().replace(re, `<strong>${args[0]}</strong>`)}

      })
    }

    return data;
  }

}
